import type { Consultation } from '@/hooks/patients/usePatientConsultations';
import theme from '@/theme';
import { Button, TextField, Typography } from '@montugroup/design-system';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { Box, styled } from '@mui/material';
import { ConsultDetailInfo } from './ConsultDetailInfo';

interface ConsultDetailProps {
  consultation: Consultation;
  onClose: () => void;
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  opacity: 0.7,
  input: {
    minHeight: theme.spacing(25)
  }
}));

export const ConsultDetail = ({ consultation, onClose }: ConsultDetailProps) => {
  return (
    <Box gap={6}>
      <Button
        variant="outlined"
        color="primary"
        size="large"
        startIcon={<ArrowBack />}
        aria-label="back to consult history"
        onClick={onClose}
        style={{ marginBottom: theme.spacing(6) }}
      >
        Back to Consult History{' '}
      </Button>

      <ConsultDetailInfo consultation={consultation} />

      <Typography component="h2" variant="h6" color="primary" marginBottom={4} marginTop={6}>
        Consult Notes
      </Typography>
      <StyledTextField
        value={consultation.notes}
        fullWidth
        multiline
        minRows={5}
        variant="outlined"
        InputProps={{
          readOnly: true
        }}
        disabled
      />
    </Box>
  );
};
